import { apiClient } from "./api";

export interface Stats {
  total_bags: number;
  total_locations: number;
  total_events: number;
  total_volunteers: number;
}

export interface KennelAggregate {
  kennel: string;
  total_bags: number;
  total_events: number;
  total_volunteers: number;
}

export interface LocationPhoto {
  photo_id: string;
  public_url: string;
  caption: string;
}

export interface Location {
  location_id: string;
  name: string;
  lat: number;
  lng: number;
  description?: string;
  total_bags: number;
  total_events: number;
  total_volunteers?: number;
  last_event_at?: string | null;
  kennels?: KennelAggregate[];
  photos?: LocationPhoto[];
}

export interface CleanupEvent {
  submission_id: string;
  location_id?: string;
  event_date?: string;
  bags_collected: number;
  volunteer_count: number;
  notes?: string;
  kennel?: string;
}

export interface SubmissionPayload {
  location_id?: string;
  new_location_name?: string;
  new_location_lat?: number;
  new_location_lng?: number;
  new_location_description?: string;
  event_date: string;
  bags_collected: number;
  volunteer_count: number;
  notes?: string;
  submitter_name?: string;
  submitter_email?: string;
  kennel?: string;
}

export interface LinkableSubmission {
  submission_id: string;
  status: string;
  event_date: string;
  location_id?: string | null;
  location_name: string;
  bags_collected: number;
  kennel?: string;
}

export const impactService = {
  getStats: () => apiClient.get<Stats>("/stats"),
  getKennelStats: () => apiClient.get<KennelAggregate[]>("/stats/kennels"),
  getKennels: () => apiClient.get<string[]>("/kennels"),
  getLocations: () => apiClient.get<Location[]>("/locations"),
  getLocationEvents: (id: string, limit = 10) => apiClient.get<CleanupEvent[]>(`/locations/${id}/events`, { limit }),
  getLinkableSubmissions: () => apiClient.get<LinkableSubmission[]>("/submissions/linkable"),
  submitCleanup: (payload: SubmissionPayload) =>
    apiClient.post<{ submission_id: string; status: string }>("/submissions", payload),
};
